import { createFileRoute } from "@tanstack/react-router";
import { CustomerModals } from "@/components/customer/customer-modals";
import CustomerTable from "@/components/customer/customer-table";
import { Button } from "@/components/ui/button";
import { useTranslate } from "@/hooks/use-translate";
import useAppStore from "@/store";
import { Plus } from "lucide-react";

export const Route = createFileRoute("/(dasboard)/customers/")({
  component: () => <CustomersPage />,
});

function CustomersPage() {
  const store = useAppStore();
  const { t } = useTranslate();
  return (
    <>
      <div className="max-w-6xl mx-auto">
        <CustomerModals />
        <header className="flex items-center justify-between mb-4">
          <h2 className="text-2xl font-semibold"> {t("Customers")} </h2>
          <Button
            onClick={() => {
              store.display.show("create_customer");
            }}
          >
            <Plus className="w-4 h-4" />
            {t("Add a customer")}
          </Button>
        </header>

        <CustomerTable />
      </div>
    </>
  );
}
